<template>
  <div class="h-full" :id="id">
    <WidgetsContainer :loading="false">
      <template #body>
        <div class="relative h-full">
          <p v-html="htmlFromMarkdown" class="prose prose-sm prose-invert pt-2 text-[12px]" />
        </div>
      </template>
    </WidgetsContainer>
  </div>
</template>
<script setup>
import { ref, onMounted, watch, inject, computed } from 'vue';
import { marked } from 'marked';

//INJECTS
const id = inject('id');
const widget = inject('widget');

const markdown = ref(
  '## Headline 2\n### Headline 3\nThis is useful for describing and organizing your dashboard layout. You can make things *italic* or **bold** or use any standard markdown syntax.'
);

const htmlFromMarkdown = computed(() => {
  return marked(markdown.value);
});
watch(
  () => widget.value.configuration,
  () => {
    if (widget.value.configuration && widget.value.configuration.markdown) {
      markdown.value = widget.value.configuration.markdown;
    }
  }
);
onMounted(() => {
  if (widget.value.configuration && widget.value.configuration.markdown) {
    markdown.value = widget.value.configuration.markdown;
  }
});
</script>
